/**
 * Light Board (WP3-LIGHTBOARD): Pulse Status inside Velora. An operatory grid
 * bound to the real appointments, one-tap chair actions, Ready for Dr with a
 * doctor queue and On my way claims, quick buttons and office pages. A
 * Marketplace add-on: the shell shows the locked panel in offices without the
 * `lightboard` entitlement and the API answers 402.
 */
import { defineManifest } from '@velora/contracts';
import { LIGHTBOARD_FEATURE, LIGHTBOARD_PERMISSIONS } from '@velora/contracts/lightboard';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'lightboard',
    title: 'Light Board',
    version: '0.1.0',
    owner: 'WP3-LIGHTBOARD',
    entitlementKey: LIGHTBOARD_FEATURE,
    permissions: [...new Set(Object.values(LIGHTBOARD_PERMISSIONS))],
    routes: [
      {
        id: 'board',
        path: '/lightboard',
        title: 'Light Board',
        officeScope: 'location-or-all',
        permission: LIGHTBOARD_PERMISSIONS.view,
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Light Board',
        group: 'operations',
        routeId: 'board',
        icon: 'activity',
        order: 20,
        permission: LIGHTBOARD_PERMISSIONS.view,
      },
    ],
    commands: [
      {
        id: 'lightboard.open',
        title: 'Go to Light Board',
        keywords: [
          'pulse status',
          'rooms',
          'operatories',
          'ready for doctor',
          'light board',
          'page',
          'schedule',
          'other views',
        ],
        routeId: 'board',
      },
    ],
    shortcuts: [{ keys: 'g b', description: 'Go to Light Board', routeId: 'board' }],
    sseEntityKeys: [],
  }),
  pages: {
    board: () => import('./LightboardPage.js'),
  },
});
